import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-[#FFF8F0] pt-14 pb-16 px-6 md:pt-20 md:pb-24 overflow-hidden" data-id="element-92">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-start space-y-6" data-id="element-94">
          <motion.div initial={{
          backgroundPosition: "-200px 0"
        }} animate={{
          backgroundPosition: "200px 0"
        }} transition={{
          duration: 3,
          repeat: Infinity,
          repeatDelay: 4,
          ease: "linear"
        }} className="inline-block text-[#2D6A4F] font-semibold px-5 py-1.5 rounded-full text-sm mb-2 shadow-md bg-[linear-gradient(110deg,rgba(45,106,79,0.12)_0%,rgba(255,255,255,0.7)_50%,rgba(45,106,79,0.12)_100%)] bg-[length:200px_100%]" data-id="element-95">
			Para madres trabajadoras 👩‍💻
			</motion.div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D6A4F] leading-tight" data-id="element-96">
            Dile adiós al pánico de las 5:00 AM: El Método de la Lonchera
            Realista
          </h1>
          <h2 className="text-lg md:text-xl text-[#5C4B3A] leading-relaxed" data-id="element-97">
            Prepara loncheras nutritivas en menos de 15 minutos con ingredientes
            de tu supermercado local y recupera tu paz mental antes de ir al
            trabajo.
          </h2>
          <div className="pt-4 w-full sm:w-auto" data-id="element-98">
            <CTAButton className="w-full sm:w-auto text-sm md:text-base" data-id="element-99" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-100">
          <div className="absolute inset-0 bg-[#2D6A4F]/5 rounded-full blur-3xl transform scale-110" data-id="element-101"></div>
          <img src="https://cdn.magicpatterns.com/uploads/tdZ1Cq2TzA62qu4Fp7smN1/portada_laptop.png" alt="Lonchera Realista 15-Min en laptop" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl object-cover border-4 border-white transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-102" />

          {/* Decorative elements */}
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute -top-6 -right-6 bg-white p-4 rounded-2xl shadow-lg z-20 hidden md:block" data-id="element-103">
            <span className="text-3xl" data-id="element-104">🥪</span>
          </motion.div>
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          duration: 3.5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1
        }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-lg z-20 hidden md:block" data-id="element-105">
            <span className="text-3xl" data-id="element-106">⏱️</span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}